import { store } from '@src/store';
import { AxiosError, InternalAxiosRequestConfig, AxiosResponse } from 'axios';
import { ApiErrorType } from '@typings/common';
import { getTokenData } from '@lib/session';
import { getB3, nanoid } from '@lib/nanoid';
import { ApiError } from './api-error';

export const requestInterceptors = (response: InternalAxiosRequestConfig) => {
    const apiPrefix = store.getState().app.apiPrefix;
    const tokenData = getTokenData();
    if (tokenData) {
        // RBO авторизация
        response.headers!['Authorization'] = `${tokenData.token_type} ${tokenData.access_token}`;
        response.headers!['Id-Token'] = tokenData.id_token;
        // требования от RBO
        response.headers!['X-Request-ID'] = nanoid();
        response.headers!['X-System-Id'] = '870:widgets';
        // Опентрейс для поиска логов в системах pay-raif
        response.headers!['X-B3-TraceId'] = getB3();
        response.headers!['X-B3-SpanId'] = getB3();
    }

    response.baseURL = apiPrefix;

    return response;
};

export const responseInterceptorOnFulfilled = (response: AxiosResponse) => response;

export const responseInterceptorOnRejected = (error: AxiosError<ApiErrorType<unknown>>) => {
    const data = error.response?.data;
    const { message, code, errors, ...rest } = data ?? {};
    throw new ApiError(message, code, errors, { ...rest });
};
